import {Injectable} from '@angular/core';
import {IndividualConfig, Toast, ToastrService} from "ngx-toastr";

@Injectable({
  providedIn: 'root'
})
export class NotifierService {

  constructor(private toastr: ToastrService) {
  }

  info(
    title: string, message: string,
    action: () => void = () => {
    },
    duration: number = 2000,
  ) {
    this.show('info', title, message, action, duration)
  }


  success(
    title: string, message: string,
    action: () => void = () => {
    },
    duration: number = 2000,
  ) {
    this.show('success', title, message, action, duration)
  }


  warning(
    title: string, message: string,
    action: () => void = () => {
    },
    duration: number = 2000,
  ) {
    this.show('warning', title, message, action, duration)
  }

  error(
    title: string, message: string,
    action: () => void = () => {
    },
    duration: number = 2000,
  ) {
    this.show('error', title, message, action, duration)
  }

  show(
    type: 'success' | 'error' | 'warning' | 'info',
    title: string, message: string,
    action: () => void = () => {
    },
    duration: number = 5000,
  ) {
    let options: Partial<IndividualConfig> = {
      /**
       * disable both timeOut and extendedTimeOut
       * default: false
       */
      disableTimeOut: false,
      /**
       * toast time to live in milliseconds
       * default: 5000
       */
      timeOut: duration,
      /**
       * toast show close button
       * default: false
       */
      closeButton: true,
      /**
       * time to close after a user hovers over toast
       * default: 1000
       */
      extendedTimeOut: 1000,
      /**
       * show toast progress bar
       * default: false
       */
      progressBar: true,
      /**
       * changes toast progress bar animation
       * default: decreasing
       */
      progressAnimation: 'decreasing',
      /**
       * render html in toast message (possibly unsafe)
       * default: false
       */
      enableHtml: true,

      /**
       * animation easing on toast
       * default: ease-in
       */
      easing: 'ease-in',
      /**
       * animation ease time on toast
       * default: 300
       */
      easeTime: 300,
      /**
       * clicking on toast dismisses it
       * default: true
       */
      tapToDismiss: true,
      /**
       * Angular toast component to be shown
       * default: Toast
       */
      toastComponent: Toast,
      /**
       * Helps show toast from a websocket or from event outside Angular
       * default: false
       */
      onActivateTick: false,
      /**
       * New toast placement
       * default: true
       */
      newestOnTop: true,
      /**
       * Payload to pass to the toast component
       */
      // payload?: ConfigPayload;
    }

    let notificationRef;
    switch (type) {
      case 'success':
        notificationRef = this.toastr.success(message, title, options);
        break;
      case 'error':
        notificationRef = this.toastr.error(message, title, options);
        break;
      case 'warning':
        notificationRef = this.toastr.warning(message, title, options);
        break;
      case 'info':
        notificationRef = this.toastr.info(message, title, options);
        break;
    }

    notificationRef.onTap.subscribe(value => {
      action()
    });
  }

  log(obj: any) {
    console.log(obj)
  }

}
